// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExperimentOutlinedSvg from "@ant-design/icons-svg/es/asn/ExperimentOutlined";
import AntdIcon from '../components/AntdIcon';

var ExperimentOutlined = function ExperimentOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExperimentOutlinedSvg
  }));
};

ExperimentOutlined.displayName = 'ExperimentOutlined';
export default React.forwardRef(ExperimentOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ExperimentOutlined.js
// module id = 1045
// module chunks = 0